import React from 'react';
import Textfield from '@atlaskit/textfield';
import { validateString } from '../../../../utils/validators/index.tsx';
import { withFormField } from '../../../with-form-field/index.tsx';
import type { ReturnComponentProps } from '../../../with-form-field/types.tsx';
import type { Props, FieldProps, InputFieldConfig, FieldValue } from './types.tsx';
import { preventMouseScrollForNumericFieldHandler } from './utils.tsx';
import { ISSUE_CREATE_COMMONS_INPUT_FIELD_TEST_ID } from './selectors.tsx';

const InputField = (props: Props): React.JSX.Element => {
	const {
		type = 'text',
		width = 'auto',
		error,
		fieldProps: { value = '', onChange, ...rest },
		autoFocus,
		isReadOnly = false,
	} = props;

	return (
		<Textfield
			{...rest}
			// @ts-expect-error - TS2322 - Type '(value: string) => void' is not assignable to type 'FormEventHandler<HTMLInputElement>'.
			onChange={onChange}
			value={value}
			type={type}
			width={width}
			step="any"
			testId={ISSUE_CREATE_COMMONS_INPUT_FIELD_TEST_ID}
			isInvalid={Boolean(error)}
			autoFocus={autoFocus}
			onWheel={preventMouseScrollForNumericFieldHandler}
			isDisabled={isReadOnly || rest.isDisabled}
		/>
	);
};

const InputFieldComponent: Flow.AbstractComponent<
	ReturnComponentProps<InputFieldConfig>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	any
> = withFormField({ validator: validateString })<InputFieldConfig, FieldValue>(
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
	InputField,
);
export default InputFieldComponent;

export { InputField };
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { FieldProps, InputFieldConfig, FieldValue };
